import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

import { BackIcon } from "../../../icons";
import Link, { ILink } from "../../ActionsSelectors/Link/Link";
import BreadcrumbItem, { IBreadcrumbItemProps } from "./BreadcrumbItem";

export interface IBreadcrumbProps {
  /**
   * Main back navigation element
   *
   * @type ILink
   */
  backLink: ILink;
  /**
   * Mobile back navigation element
   *
   * @type ILink
   */
  mobileBackLink: ILink;
  /**
   * List of Breadcrumb elements
   * Rendered in form of 'ol' list
   *
   * Note: You can pass item in form of children
   * In this case last one will have 'active' class by default
   */
  itemsList?: IBreadcrumbItemProps[];
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    root?: string;
  };
  children?: ReactNode;
  withPadding?: boolean;
}

const Breadcrumb: FC<IBreadcrumbProps> = ({
  backLink,
  mobileBackLink,
  itemsList,
  classes,
  children,
  withPadding = true,
}) => {
  const rootClasses = classNames("breadcrumb", classes?.root);

  return (
    <nav aria-label="breadcrumb" className={rootClasses}>
      <Link
        href={backLink.href}
        text={backLink.text}
        classes={{
          root: classNames("breadcrumb-back", {
            "pe-0": !withPadding,
          }),
        }}
      >
        <BackIcon />
      </Link>

      <ol className="breadcrumb-list">
        {itemsList
          ? itemsList.map((item, index) => {
              return (
                <BreadcrumbItem
                  key={item.text + item.href}
                  text={item.text}
                  href={item.href}
                  active={index === itemsList.length - 1}
                />
              );
            })
          : children}
      </ol>

      <Link
        href={mobileBackLink.href}
        text={mobileBackLink.text}
        classes={{ root: "breadcrumb-back breadcrumb-back--mobile" }}
      >
        <BackIcon />
      </Link>
    </nav>
  );
};

export default Breadcrumb;
